import { memo } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';
import { ButtonOwnProps } from './model';

import './styles.scss';

export const View = memo(({
    className,
    variant = 'primary',
    icon,
    value,
    ...props
}: ButtonOwnProps) => {
    return (
        <Button
            shape="round"
            className={classNames(variant, { 'has-icon': Boolean(icon) }, className)}
            icon={icon}
            {...props}
        >
            {value}
        </Button>
    );
});
